import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSyncExecuting = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeWidth: 3,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 8,
			stroke: "#cdd4da"
		}), /* @__PURE__ */ _jsx("path", {
			d: "m2 10c0-4.41828 3.58172-8 8-8",
			stroke: "#684adf",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export { SvgSyncExecuting as ReactComponent };
